import { MessageSquare } from 'lucide-react'
import type { LeagueEvent } from '../types'
import styles from './EventsFeed.module.css'

type EventsFeedProps = {
  events: LeagueEvent[]
}

export function EventsFeed({ events }: EventsFeedProps) {
  if (events.length === 0) {
    return (
      <div className={styles.empty}>
        <MessageSquare size={32} className={styles.emptyIcon} />
        <p className={styles.emptyTitle}>Nenhum evento ainda</p>
        <p className={styles.emptyHint}>
          Eventos como mudanças de posição e provocações aparecerão aqui durante a competição.
        </p>
      </div>
    )
  }

  // TODO: render events when backend is ready
  return (
    <ul className={styles.list}>
      {events.map((event) => (
        <li key={event.id} className={styles.item}>
          <span className={styles.content}>{event.content}</span>
          <span className={styles.time}>{event.timestamp}</span>
        </li>
      ))}
    </ul>
  )
}
